// activityTradeStar
export default {
  routerTitle: '寻找盈宝港美股交易之星',
  shareTitle: '寻找盈宝港美股交易之星，最高拿HKD4000',
  shareDesc: '限时福利，多交易多得',

  welfare: '福利',
  seeMore: '查看更多',

  dayTradeDaBiao: '交易日内融笔数达标，奖励高达',
  dtErWai: '额外再享免佣!',

  dtTableHeader1: '交易港/美股<br/>日内融笔数',
  dtTableHeader2: '奖励金额<br/>累计金额',
  dtTableHeader3: '额外奖励',
  monthFeeHk: '个月港股免佣券',
  dtTableTips: '注：免佣券奖励需达标且活动结束后7个工作日内发放。',

  joinNow: '即刻参与',
  dtSupportStocks: '日内融支持股票',
  txkgStock: '腾讯控股（00700）',
  albbStock: '阿里巴巴-SW（09988）',
  bdjtStock: '百度集团-SW（09888）',
  jdjtStock: '京东集团-SW（09618）',
  mtStock: '美团-W（03690）',
  support20x: '支持20倍融资',

  howToOpenDt: '如何开通日内融',
  dtStep1: '第一步：即刻参与',
  dtStep2: '第二步：资产页>点击日内融入口',
  dtStep3: '第三步：开通日内融资账户',
  dtStep4: '第四步：日内融资交易',
  dtOperateIntroLabel: '具体操作指引',
  dtOperateIntroValue: '日内融资操作交易攻略指引',
  wbDtYsTitle: '盈宝日内融资的优势',
  wbDtYs1: '高杠杆日内短线交易',
  wbDtYs2: '最高支持20倍杠杆',
  wbDtYs3: '0融资利息',
  wbDtYs4: '当天建仓，当天平仓',

  normalTradeDaBiao: '交易港/美股笔数达标，奖励高达',
  perFute: '股福特股票',
  accumulate: '累计',
  tradeHkAndUs: '交易港/美股',
  perCount: '笔',
  perStock: '股',
  normalTradeTips: '注：港美股交易笔数不包含日内融的交易。',

  wbYsTitle: '盈宝优势',
  wbDtYsDesc11: '多品种交易',
  wbDtYsDesc12: '支持港股、美股、牛熊涡轮内证、ETF',
  wbDtYsDesc21: '杠杆放大可能',
  wbDtYsDesc22: '20倍港美股日内融，放大投资机会',
  wbDtYsDesc31: '低利息成本',
  wbDtYsDesc32: '孖展利息低至5.6%，降低投资成本',
  wbDtYsDesc41: '会员特权',
  wbDtYsDesc42: 'V3会员专享0元佣金，交易1亿港元仅需5元平台费',
  wbDtYsDesc51: '智能交易',
  wbDtYsDesc52: '条件单、止损止盈，策略在手，交易我有'
}
